import { useQuery } from '@apollo/client/react';
import { STAFF_EMPLOYEE_PEERS } from '@staff-app/graphql-client';
import type { EmployeePeer } from '@staff-app/shared-types';
import { DevicesTable } from '../components/DevicesTable';
import { PeersTableBySubnet } from '../components/PeersTableBySubnet';

export function EmployeePeersPage() {
  const { data, loading, error } = useQuery<{ staffEmployeePeers: EmployeePeer[] }>(
    STAFF_EMPLOYEE_PEERS,
    {
      fetchPolicy: 'cache-and-network',
    },
  );
  const peers = data?.staffEmployeePeers ?? [];

  return (
    <div className="flex flex-col gap-8 p-6" data-testid="employee-peers-page">
      <div>
        <h1 className="text-2xl font-bold text-foreground">{'Network / Peers'}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {'Everyone and everything with WireGuard credentials. Read-only.'}
        </p>
      </div>

      {error ? (
        <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
          {error.message}
        </div>
      ) : loading && !peers.length ? (
        <div className="text-sm text-muted-foreground">{'Loading peers…'}</div>
      ) : (
        <PeersTableBySubnet peers={peers} />
      )}

      <DevicesTable />
    </div>
  );
}
